import React from 'react'

const ageNotFound = () => {
    return (
        <div>PageNotFound</div>
    )
}

export default ageNotFound